import { IExportColumnModel } from '../../../../../src/shared/models'

export const ChangeHistoryColumnList: IExportColumnModel[] = [
    {
        isAllChecked: true,
        name: "Fields from account change histories",
        value: "account_change_histories",
        columns: [
            {
                name: "Id",
                value: "id",
                checked: true,
            },
            {
                name: "Item Type",
                value: "item_type",
                checked: true,
            },
            {
                name: "Item Id",
                value: "item_id",
                checked: true,
            },
            {
                name: "Event",
                value: "event",
                checked: true,
            },
            {
                name: "Edited By",
                value: "whodunnit",
                checked: true,
            },
            {
                name: "Old Value",
                value: "object",
                checked: true,
            },
            {
                name: "New Value",
                value: "object_changes",
                checked: true,
            },
             {
                name: "Created At",
                value: "created_at",
                checked: true,
            },
             {
                name: "IP",
                value: "ip",
                checked: true,
            }          
        ]

    },
    {
        isAllChecked: true,
        name: "Fields from associated account",
        value: "accounts",
        columns: [
            {
                name: "Id",
                value: "Id",
                checked: true,
            },
             {
                name: "Domain",
                value: "domain",
                checked: true,
            }, 
            {
                name: "Logo URL",
                value: "logo_url",
                checked: true,
            },
            {
                name: "Created At",
                value: "created_at",
                checked: true,
            },
            {
                name: "Updated At",
                value: "updated_at",
                checked: true,
            }, 
            {
                name: "URL",
                value: "url",
                checked: true,
            },
            {
                name: "Priority",
                value: "priority",
                checked: true,
            },
            {
                name: "Favicon URL",
                value: "favicon_url",
                checked: true,
            },    
            {
                name: "State",
                value: "state",
                checked: true,
            },
            {
                name: "Trial",
                value: "trial",
                checked: true,
            },
            {
                name: "Active",
                value: "active",
                checked: true,
            },
            {
                name: "SFTP Account Name",
                value: "sftp_account_name",
                checked: true,
            }, 
            {
                name: "Notes",
                value: "notes",
                checked: true,
            }, 
            {
                name: "Contract Unit Count",
                value: "contract_unit_count",
                checked: true,
            },  
            {
                name: "Contract Unit Price",
                value: "contract_unit_price",
                checked: true,
            },
            {
                name: "Contract Billing Schedule",
                value: "contract_billing_schedule",
                checked: true,
            },
            {
                name: "Contract Date",
                value: "contract_date",
                checked: true,
            },
            {
                name: "Contract Renewal Date",
                value: "contract_renewal_date",
                checked: true,
            },
            {
                name: "Graph",
                value: "graph",
                checked: true,
            },
            {
                name: "Report Status",
                value: "report_status",
                checked: true,
            },
            {
                name: "Monthly Offset",
                value: "monthly_offset",
                checked: true,
            },
            {
                name: "Pause Scheduled Reports",
                value: "pause_scheduled_reports",
                checked: true,
            },
            {
                name: "Report Schedule Start",
                value: "report_schedule_start",
                checked: true,
            },
            {
                name: "Report Schedule Stop",
                value: "report_schedule_stop",
                checked: true,
            },
            {
                name: "Database Engine Id",
                value: "database_engine_id",
                checked: true,
            },
            {
                name: "Transition Database Engine Id",
                value: "transition_database_engine_id",
                checked: true,
            },
            {
                name: "Data Retention Days",
                value: "data_retention_days",
                checked: true,
            },
            {
                name: "Federated",
                value: "federated",
                checked: true,
            }
            
        ]

    },
]